import { lazy } from 'react';
const latexTransfer = lazy(() => import('./latexTransfer'));

const latexTransferRoutes = [
  {
    path: '/latex-transfer',
    component: latexTransfer
  }
];

export default latexTransferRoutes;
